<div class="col-lg-12 fondooscuro animated fadeIn bordeado">
  <!--tit-->
  <div class="bordeado2">
    <table class="table table-condensed">
      <thead>
          <tr>
              <td class="izq">&nbsp;</td>
              <td class="whitestit izq"><strong>CARGA Y EMISION DE ORDENES DE PAGO <i *ngIf="loading" class="fas fa-cog fa-spin"></i></strong></td>
              <td class="whitestit izq"><strong>ultima fué: 000{{ultop}}</strong></td>
              <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
              <td class="whitestit2"><strong>{{ fecha_hoy }}</strong></td>
          </tr>
      </thead>
    </table>
    
  </div>
  <!--medio-->
  <div class="whites bordeado2">
    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Número de O.P...:&nbsp;&nbsp;&nbsp;000{{opactual}}</p>
    <br>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Fecha...........:&nbsp;&nbsp;&nbsp;<input class="bg-dark text-white" type="date" id="hoy" name="hoy" [(ngModel)]="hoy" value="{{hoy}}"> </p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Señores.........:&nbsp;&nbsp;
      <span>TIPO PAGO:
        <select [disabled]="registros>=1" (click)="calcularSec()" [(ngModel)]="tipoOrden" name="tipoOrden" id="tipoOrden" class="bg-dark text-white">
          <option>SISTEMA</option>
          <option>EXTERNO</option>
        </select>
        &nbsp;&nbsp;
      </span>
  
      <span *ngIf="tipoOrden != null && tipoOrden != ''">
          Sec/Del:
      </span>
      <select  [disabled]="(registros>=1)" (click)="calcularGastosSistema()" *ngIf="tipoOrden =='SISTEMA'" [(ngModel)]="filtroSec" name="filtroSec" id="filtroSec" class="bg-dark text-white">
        <option *ngFor="let secSis of dataSourceSeccionales" [ngValue]="secSis.IDSEC">{{ secSis.SECDEL }} - fondo:({{ secSis.FONDO | currency:"$" }})</option>
      </select>
      <select  *ngIf="tipoOrden =='EXTERNO'" [(ngModel)]="filtroSec" name="filtroSec" id="filtroSec" class="bg-dark text-white">
        <option *ngFor="let sec of dsSec" [ngValue]="sec.id_usuario">ASIGNAR A: {{ sec.Descripcion }}</option>
      </select>
      &nbsp;    
      <span *ngIf="tipoOrden =='EXTERNO'">
          Dato Adic.
      </span>
      &nbsp;
      <span *ngIf="tipoOrden=='EXTERNO'">
        <input  [(ngModel)]="detAdicional" name="detAdicional" id="detAdicional" class="bg-dark text-white">
      </span>
    </p>

    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Motivo..........:
      &nbsp;
      <span *ngIf="tipoOrden=='EXTERNO'">
        <input  [(ngModel)]="detExterno" name="detExterno" id="detExterno" class="bg-dark text-white">
      </span>
      &nbsp;
      <span *ngIf="tipoOrden=='EXTERNO'">Importe:</span>&nbsp;
      <span *ngIf="tipoOrden=='EXTERNO'">
        <input type="number" [(ngModel)]="impExterno" name="impExterno" id="impExterno" class="bg-dark text-white">
      </span>
      &nbsp;<span *ngIf="tipoOrden=='EXTERNO'">Categoria:</span>
      &nbsp;
      <select *ngIf="(tipoOrden == 'EXTERNO') " class="bg-dark text-white"  [(ngModel)]="catExterno" name="catExterno" id="catExterno">
        <option *ngFor="let cat of dataSourceCategorias;" [ngValue]="cat.codysub" >{{ cat.detalle | uppercase}} ({{cat.codigo}}-{{cat.sub_codigo}})</option>
      </select>
      <select *ngIf="(tipoOrden == 'SISTEMA') && (filtroSec)" class="bg-dark text-white"  [(ngModel)]="filtroGAS" name="filtroGAS" id="filtroGAS">
        <option>TODOS</option>
        <option *ngFor="let gas of dataSourceGastos" [ngValue]="gas.COD_GASTO">CODGAS:[{{ gas.COD_GASTO }}] - IMP:({{ gas.IMPORTE | currency:"$" }})</option>
      </select>
      &nbsp;&nbsp;
      <button *ngIf="(filtroGAS != 'TODOS') && (filtroGAS != null && filtroGAS != '') && (puedepaga==true) && (this.tipoOrden=='SISTEMA')" mat-icon-button color="accent" (click)="guardarDetallito()" data-toggle="tooltip" data-placement="right" title="AÑADIR!">
          <mat-icon aria-label="checks">playlist_add</mat-icon>
      </button>
      <button *ngIf="(filtroGAS == 'TODOS') && (filtroGAS != null && filtroGAS != '') && (puedepaga==true) && (this.tipoOrden=='SISTEMA')" mat-icon-button color="accent" (click)="guardarDetallitoTODOS()" data-toggle="tooltip" data-placement="right" title="AÑADIR!">
        <mat-icon aria-label="checks">playlist_add</mat-icon>
      </button>
      <button *ngIf="(detExterno != '') && (detExterno != null) && (impExterno != '') && (impExterno != null) && (catExterno != null) && (catExterno != '') && (tipoOrden=='EXTERNO')" mat-icon-button color="btn-primary" (click)="guardarDetallitoEXTERNO(); limpiarDatosExternos();" data-toggle="tooltip" data-placement="right" title="AÑADIR!">
        <mat-icon aria-label="checks">playlist_add</mat-icon>
      </button>
    </p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Forma de Pago:&nbsp;&nbsp;
      <select [(ngModel)]="formaPago" name="formaaPago" id="formaPago" class="bg-dark text-white">
        <option>TRANSFERENCIA</option>
        <option>CHEQUE</option>
        <option value ="TARJETA" >TARJETA DE CREDITO</option>
      </select>
      &nbsp;&nbsp;&nbsp;BANCO:&nbsp;&nbsp;
      <select *ngIf="formaPago == 'TRANSFERENCIA'" [(ngModel)]="cuentaBanco" name="cuentaBanco" id="cuentaBanco" class="bg-dark text-white">
        <option value="111400">BANCO NACION TRANSF-111400 </option>
        <option value ="111402">BANCO ITAU TRANSF-111402</option>
      </select>
   
      <select *ngIf="formaPago == 'CHEQUE'" [(ngModel)]="cuentaBanco" name="cuentaBanco" id="cuentaBanco" class="bg-dark text-white">
        <option value="111401">BANCO NACION CTACTE-111401</option>
        <option value="111403">BANCO ITAU CTACTE-111403</option>
      </select>
   
<!--   <span *ngIf="formaPago == 'TRANSFERENCIA'">
       
        <select [(ngModel)]="cuentaBanco" name="cuentaBanco" id="cuentaBanco" class="bg-dark text-white">
          <option value="111400">BANCO NACION TRANSF-111400 </option>
          <option value ="111402">BANCO ITAU TRANSF-111402</option>
        </select>
      </span>
      <span *ngIf="formaPago == 'CHEQUE'">
        &nbsp;&nbsp;&nbsp;BANCO:&nbsp;&nbsp;
         <select [(ngModel)]="cuentaBanco" name="cuentaBanco" id="cuentaBanco" class="bg-dark text-white">
           <option value="111401">BANCO NACION CTACTE-111401</option>
           <option value="111403">BANCO ITAU CTACTE-111403</option>
         </select>
       </span>
      -->

      <span *ngIf="(formaPago == 'CHEQUE') || (formaPago == 'TRANSFERENCIA') || (formaPago == 'TARJETA')">
         &nbsp;&nbsp;&nbsp;Nro. Operac.:&nbsp;&nbsp;
         <input type="number" [(ngModel)]="nroOpera" name="nroOpera" id="nroOpera" class="bg-dark text-white">
      </span>
    </p>
  </div>

  <!--abajo-->
  <div>  
    <br>
  </div>
  <!--***************************************************************************-->
  <div id="tablita">
      <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8" style="background-color: rgb(204, 204, 204); ">
          <!-- id Column -->
          <ng-container matColumnDef="i">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> id. </th>
              <td mat-cell *matCellDef="let element"> {{element.i}} </td>
          </ng-container>
          <!-- Position Column -->
          <ng-container matColumnDef="codgasto">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> CODGAS</th>
              <td class="fondooscuro whites" mat-cell *matCellDef="let element"> {{element.codgasto}} </td>
          </ng-container>
          <!-- Position Column -->
          <ng-container matColumnDef="cuenta">
              <th  mat-header-cell *matHeaderCellDef mat-sort-header> CUENTA</th>
              <td  class="fondooscuro whites" mat-cell *matCellDef="let element"> {{element.cuenta}} </td>
          </ng-container>
          <!-- Name Column -->
          <ng-container matColumnDef="concepto">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> CONCEPTO <span *ngIf="tipoOrden=='EXTERNO'"> - SEC/DEL</span> </th>
              <td class="fondooscuro whites" mat-cell *matCellDef="let element"> {{element.concepto | uppercase}} </td>
          </ng-container>
          <!-- Weight Column -->
          <ng-container matColumnDef="leyenda">
              <th hidden mat-header-cell *matHeaderCellDef mat-sort-header> LEYENDA</th>
              <td hidden class="fondooscuro whites" mat-cell *matCellDef="let element"> {{element.leyenda | uppercase}} </td>
          </ng-container>
          <!-- Symbol Column -->
          <ng-container matColumnDef="debe">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> DEBE </th>
              <td class="fondooscuro whites" mat-cell *matCellDef="let element"> {{element.debe | currency:"$" }} </td>
          </ng-container>
          <!-- Symbol Column -->
          <ng-container matColumnDef="origa">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> ORIGA </th>
              <td class="fondooscuro whites" mat-cell *matCellDef="let element"> {{element.origa | currency:"$" }}
              </td>
          </ng-container>
          <!-- borrar Column -->
          <ng-container matColumnDef="x">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Borrar </th>
              <td class="fondooscuro whites" mat-cell *matCellDef="let element">
                  <button hidden id="botonBorra" mat-icon-button color="accent" (click)="removeAt(element.i)">
                      <mat-icon aria-label="Delete">delete</mat-icon>
                  </button>
                  <button id="botonBorraModal" mat-icon-button color="accent" (click)="enviaItem(element.i)" data-toggle="modal" data-target="#modalDelete">
                      <mat-icon aria-label="Delete">delete</mat-icon>
                  </button>
              </td>
          </ng-container>

          <tr class="table-header" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
  </div>
<!--***************************************************************************-->
  <!--mas abajo-->
  <div>  
    <br>
    <table class="table table-condensed">
      <thead>
          <tr *ngIf="(dataSource.data.length >=1)">
              <td class="whites2"><strong>Cuenta</strong></td>
              <td class="whites2"><strong>CUENTA</strong></td>
              <td class="whites2" ><strong>CONCEPTO</strong></td>
              <td class="whites2" ><strong>NRO. OPERAC.</strong></td>
              <td class="whites2" ><strong>FECHA-VTO.</strong></td>
              <td class="whites2" ><strong>HABER</strong></td>
          </tr>
        <tr *ngIf="(dataSource.data.length >=1)">
            <td class="fondooscuro whites"><strong>PAGOS </strong></td>
            <td class="fondooscuro whites"><strong>{{ cuentaBanco }} </strong></td>
            <td class="fondooscuro whites" ><strong>{{ descCuentaBanco }}</strong></td>
            <td *ngIf="formaPago == 'TARJETA'" class="fondooscuro whites" ><strong>TARJETA DE CREDITO</strong></td>
            <td class="fondooscuro whites" ><strong>{{ nroOpera }}</strong></td>
            <td class="fondooscuro whites" ><strong>{{ hoy }}</strong></td>
            <td class="fondooscuro whites" ><strong>SUBTOTAL {{ sumatoria | currency:"$"}}</strong></td>
        </tr>
        <tr *ngIf="(tipoOrden == 'SISTEMA') && (TIENEFONDO == true) && (dataSource.data.length >=1)">
          <td class="fondooscuro whites"><strong>--- </strong></td>
          <td class="fondooscuro whites"><strong>--- </strong></td>
          <td class="fondooscuro whites" ><strong>DINERO A CUENTA</strong></td>
          <td *ngIf="formaPago == 'TARJETA'" class="fondooscuro whites" ><strong>---</strong></td>
          <td class="fondooscuro whites" ><strong>---</strong></td>
          <td class="fondooscuro whites" ><strong>---</strong></td>
          <td class="fondooscuro whites" ><strong>FONDO (-){{ fondito | currency:"$"}}</strong></td>
        </tr>
        <tr *ngIf="(dataSource.data.length >=1)">
          <td class="fondooscuro whites"><strong>--- </strong></td>
          <td class="fondooscuro whites"><strong>--- </strong></td>
          <td class="fondooscuro whites" ><strong></strong></td>
          <td *ngIf="formaPago == 'TARJETA'" class="fondooscuro whites" ><strong>---</strong></td>
          <td class="fondooscuro whites" ><strong>---</strong></td>
          <td class="fondooscuro whites" ><strong>---</strong></td>
          <td *ngIf="(TIENEFONDO == false)" class="fondooscuro whites" ><strong> TOTAL {{ sumatoria | currency:"$"}}</strong></td>
          <td *ngIf="(tipoOrden == 'SISTEMA') && (TIENEFONDO == true)" class="fondooscuro whites" ><strong>TOTAL OP {{ sumatoria - fondito | currency:"$"}}</strong></td>
        </tr>
      </thead>
    </table> 
    <br>
  </div>
  
  <table class="table table-condensed">
    <thead>
      <tr>
        <td class="whites" ><strong>&nbsp;&nbsp;</strong></td>
        <td class="whites" ><strong>&nbsp;&nbsp;</strong></td>
        <td class="whites" ><strong>&nbsp;&nbsp;</strong></td>
        <td class="whites" style="cursor: pointer" ><strong>Ayuda</strong></td>
        <td class="whites" ><strong>&nbsp;&nbsp;</strong></td>
        <td class="whites" ><strong>&nbsp;&nbsp;</strong></td>
        <td class="whites" ><strong>&nbsp;&nbsp;</strong></td>
        <td *ngIf="PUEDEPAGAR" data-toggle="modal" data-target="#modalPagar" class="whites2" style="cursor: pointer"><strong>IMPRIMIR O.P.</strong></td>
        <td *ngIf="!PUEDEPAGAR" data-toggle="modal" data-target="#modalfaltadato" class="whites2" style="cursor: pointer"><strong>IMPRIMIR O.P.</strong></td>
        <td class="whites" ><strong>&nbsp;&nbsp;</strong></td>
        <td class="whites" ><strong>&nbsp;&nbsp;</strong></td>
        <td class="whites" ><strong>&nbsp;&nbsp;</strong></td>
        <td routerLink="/home" (click)="limpiar()" class="whites" style="cursor: pointer" ><strong>Cancelar</strong></td>
        <td class="whites" ><strong>&nbsp;&nbsp;</strong></td>
        <td class="whites" ><strong>&nbsp;&nbsp;</strong></td>
        <td class="whites" ><strong>&nbsp;&nbsp;</strong></td>
      </tr>
    </thead>
  </table> 
</div>

<!-- Modal pagar -->
<div style="margin-top: 280px" class="modal fade" id="modalPagar" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
      <div id="modalito2" class="modal-content">

          <div *ngIf="tipoOrden == 'SISTEMA'" class="modal-body" style="text-align: center;">
              ¿PAGAR GASTO/S: {{arrgastos}}?
              <img style="height: 50px; width: 50px;" src="../../../assets/img/okk.png" alt="">
          </div>
          <div *ngIf="tipoOrden == 'EXTERNO'" class="modal-body" style="text-align: center;">
              ¿PAGAR GASTO EXTERNO?
              <img style="height: 50px; width: 50px;" src="../../../assets/img/okk.png" alt="">
          </div>
          <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Volver</button>
              <a  id="botonImprime" hidden class="whites" style="cursor: pointer" type="button" target="_blank" routerLink="/impresionorden">CANCEL</a>
              <a *ngIf="tipoOrden == 'SISTEMA'" target="_blank" routerLink="/impresionorden" style="cursor: pointer" data-dismiss="modal" (click)="pagar()" type="button" class="btn btn-primary">CONFIRMAR PAGO</a>
              <a *ngIf="tipoOrden == 'EXTERNO'" target="_blank" routerLink="/impresionorden" style="cursor: pointer" data-dismiss="modal" (click)="enviarFormulario()" type="button" class="btn btn-primary">CONFIRMAR PAGO</a>
              
          </div>
      </div>
  </div>
</div>

<!-- Modal confirma eliminar item -->
<div style="margin-top: 280px" class="modal fade" id="modalDelete" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div id="modalito2" class="modal-content">

            <div class="modal-body">
                ¿Eliminar item {{temporal}}?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Volver</button>
                <button data-dismiss="modal" (click)="removeAt(temporal)" type="button" class="btn btn-primary">ELIMINAR</button>
            </div>
        </div>
    </div>
</div>

<!-- Modal faltan datos-->
<div style="margin-top: 280px" class="modal fade" id="modalfaltadato" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
      <div id="modalito2" class="modal-content">

          <div class="modal-body" style="text-align: center;">
              COMPLETE TODOS LOS DATOS..
              <img style="height: 50px; width: 50px;" src="../../../assets/img/errr.jpg" alt="">
          </div>
          <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Volver</button>
          </div>
      </div>
  </div>
</div>